export default __webpack_public_path__ + "static/media/companyEquityPlan.46fe0360.svg";